import { render, staticRenderFns } from "./ResidenceNavigation.vue?vue&type=template&id=5062ca8c&"
import script from "./ResidenceNavigation.vue?vue&type=script&lang=js&"
export * from "./ResidenceNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5062ca8c')) {
      api.createRecord('5062ca8c', component.options)
    } else {
      api.reload('5062ca8c', component.options)
    }
    module.hot.accept("./ResidenceNavigation.vue?vue&type=template&id=5062ca8c&", function () {
      api.rerender('5062ca8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResidenceNavigation.vue"
export default component.exports